import React from "react";
import { Well } from "@sketchpixy/rubix";

const Toolbar = ({ children }) => (
  <Well id='toolbar'>
      {children}
  </Well>
);

export default Toolbar;




// WEBPACK FOOTER //
// ./src/components/common/Toolbar.js